import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import app from './config';

// null ohne Firebase-Konfiguration - siehe config.js.
const db = app ? getFirestore(app) : null;

if (db && process.env.REACT_APP_USE_EMULATORS === 'true') {
  connectFirestoreEmulator(db, 'localhost', 8080);
}

export default db;
